import { useState, useEffect, useRef } from "react";
import api from "../utils/api";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Form,
  InputGroup,
  Dropdown,
  Offcanvas,
} from "react-bootstrap";
import {
  FaTrophy,
  FaFutbol,
  FaHorse,
  FaDog,
  FaUser,
  FaUserPlus,
  FaSignInAlt,
  FaGlobe,
  FaGamepad,
  FaFish,
  FaBars,
} from "react-icons/fa";
import {
  MdSportsCricket,
  MdCasino,
  MdSportsTennis,
  MdHowToVote,
} from "react-icons/md";
import { GiCardRandom } from "react-icons/gi";
import "./Header.css";
import LoginModal from "./../userAuth/LoginModal";
import SignUpModal from "../userAuth/SignUpModal";
import MobileMenuScroll from "./MobileMenuScroll";
import { Link, NavLink, useNavigate } from "react-router-dom";
import LanguageModal from "./LanguageModal";
import { useDispatch, useSelector } from "react-redux";
import UserDashboard from "../userAuth/user/UserDashboard";

import { openLoginModal, closeLoginModal } from "../../redux/authSlice";

// import { useTranslation } from "react-i18next";
const img1 = require("../assets/jsk/logo.png");

export default function Header() {
  const { user } = useSelector((state) => state.user);
  const { isLoginModalOpen } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [time, setTime] = useState(new Date());
  const [show, setShow] = useState(false);
  // const [showLogin, setShowLogin] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showLangModal, setShowLangModal] = useState(false);
  const [activeLang, setActiveLang] = useState("EN");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [headerSearch, setHeaderSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchBoxRef = useRef(null);

  // Live global game search: fetch matches into a dropdown (no redirect)
  useEffect(() => {
    const q = headerSearch.trim();
    if (q.length < 2) {
      setSearchResults([]);
      setSearchOpen(false);
      return;
    }
    setSearchLoading(true);
    setSearchOpen(true);
    const timer = setTimeout(async () => {
      try {
        const res = await api.get("/games", { params: { limit: 10, name: q } });
        setSearchResults(res.data.success ? res.data.data : []);
      } catch {
        setSearchResults([]);
      } finally {
        setSearchLoading(false);
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [headerSearch]);

  // Close search dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const openGameFromSearch = (game) => {
    setSearchOpen(false);
    setHeaderSearch("");
    if (game.slug) navigate(`/games/${game.slug}`);
  };

  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const changeLanguage = (lang) => {
    const googleSelect = document.querySelector("select.goog-te-combo");
    if (googleSelect) {
      googleSelect.value = lang;
      googleSelect.dispatchEvent(new Event("change"));
      setActiveLang(lang.toUpperCase());
    }
  };

  return (
    <header style={{ height: "92px" }}>
      {/* ==================== TOP BAR ==================== */}
      <div className="bg-black text-white py-2 border-bottom border-dark">
        <Container className="d-flex justify-content-between align-items-center">
          <FaBars
            className="d-lg-none ms-2"
            size={22}
            onClick={handleShow}
            style={{ cursor: "pointer" }}
          />
          <div
            className="d-flex align-items-center"
            onClick={() => navigate("/")}
          >
            <img
              src={img1}
              alt="Logo"
              style={{ height: "50px", cursor: "pointer" }}
            />
          </div>

          {/* <div className="d-none d-md-block">
            <small className="text-white">🕒 {time.toLocaleString()}</small>
          </div> */}

          <div
            className="d-none d-md-block w-25 header-search-box"
            ref={searchBoxRef}
          >
            <Form onSubmit={(e) => e.preventDefault()}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search games..."
                  className="rounded-pill"
                  value={headerSearch}
                  onChange={(e) => setHeaderSearch(e.target.value)}
                  onFocus={() => {
                    if (headerSearch.trim().length >= 2) setSearchOpen(true);
                  }}
                />
              </InputGroup>
            </Form>

            {searchOpen && (
              <div className="header-search-dropdown">
                {searchLoading ? (
                  <div className="header-search-status">Searching...</div>
                ) : searchResults.length === 0 ? (
                  <div className="header-search-status">No games found</div>
                ) : (
                  <div className="header-search-results">
                    {searchResults.map((game) => (
                      <button
                        key={game._id}
                        className="header-search-item"
                        onClick={() => openGameFromSearch(game)}
                      >
                        <span className="header-search-thumb">
                          <FaGamepad className="header-search-thumb-fallback" />
                          {game.thumbnail && (
                            <img
                              src={game.thumbnail}
                              alt=""
                              className="header-search-thumb-img"
                              onError={(e) => (e.currentTarget.style.display = "none")}
                            />
                          )}
                        </span>
                        <span className="header-search-meta">
                          <span className="header-search-name">{game.name}</span>
                          <span className="header-search-provider">
                            {game.provider?.name || game.gameType || ""}
                          </span>
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="d-flex gap-1 align-items-center">
            {!user && (
              <Button
                variant="warning"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1"
                onClick={() => dispatch(openLoginModal())}
              >
                Log In
              </Button>
            )}
            {!user && (
              <Button
                variant="warning"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1 d-none d-md-block"
                onClick={() => {
                  handleClose();
                  setShowSignUp(true);
                }}
              >
                Sign Up
              </Button>
            )}

            {user && (
              <>
                <div
                  className="d-none d-lg-flex align-items-center me-2 bg-dark rounded px-2 py-1 border border-secondary"
                  style={{ height: "31px" }}
                >
                  <small
                    className="text-white me-1"
                    style={{ fontSize: "11px", opacity: 0.8 }}
                  >
                    Balance:
                  </small>
                  <span
                    className="text-warning fw-bold"
                    style={{ fontSize: "14px" }}
                  >
                    ₹{user?.wallet?.balance?.toLocaleString() || "0"}
                  </span>
                </div>

                <div
                  className="d-none d-lg-flex align-items-center me-2 bg-dark rounded px-2 py-1 border border-secondary"
                  style={{ height: "31px" }}
                >
                  <small
                    className="text-white me-1"
                    style={{ fontSize: "11px", opacity: 0.8 }}
                  >
                    Bonus:
                  </small>
                  <span
                    className="text-info fw-bold"
                    style={{ fontSize: "14px" }}
                  >
                    ₹{user?.wallet?.bonusBalance?.toLocaleString() || "0"}
                  </span>
                </div>

                <Button
                  variant="success"
                  size="sm"
                  className="fw-bold me-2"
                  onClick={() => navigate("/deposit")}
                >
                  Deposit
                </Button>

                <Button
                  variant="primary"
                  size="sm"
                  className="fw-bold"
                  onClick={() => setShowUserMenu(true)}
                >
                  <div className="d-flex align-items-center gap-1">
                    <FaUser />
                    {user.userId}
                  </div>
                </Button>
              </>
            )}
            <Offcanvas
              show={showUserMenu}
              onHide={() => setShowUserMenu(false)}
              placement="end"
              className="bg-dark text-light"
            >
              <Offcanvas.Header closeButton closeVariant="white">
                <Offcanvas.Title className="d-flex align-items-center gap-2 fs-5 fw-bold">
                  <FaUser size={16} className="text-warning" /> Account
                </Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body className="p-0">
                {/* DASHBOARD */}
                <UserDashboard onClose={() => setShowUserMenu(false)} />
              </Offcanvas.Body>
            </Offcanvas>

            {/* <Button
              variant="outline-secondary"
              size="sm"
              className="d-flex align-items-center gap-1"
              onClick={() => setShowLangModal(true)}
            >
              <FaGlobe /> {activeLang}
            </Button> */}
          </div>
        </Container>
      </div>

      {/* ==================== MENU (Mobile + Desktop) ==================== */}
      <Navbar expand="lg" className="secondheader shadow-sm py-0">
        <Container fluid>
          <Navbar.Toggle aria-controls="main-menu" />
          <Navbar.Collapse id="main-menu" className="justify-content-center">
            <div className="marquee-wrapper">
              <Nav className="fw-semibold text-uppercase nav-sm flex-nowrap secondheader-nav">
                <NavLink
                  to="/"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  <FaTrophy className="me-1" /> Home
                </NavLink>

                <NavLink
                  to="/casino"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  <MdCasino className="me-1" /> Live Casino
                </NavLink>

                <NavLink
                  to="/sports"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  <MdSportsCricket className="me-1" /> Sports
                </NavLink>

                {/* <NavLink to="/cricket" className="nav-link d-flex align-items-center gap-0.5">
                  <MdSportsCricket className="me-1" /> Cricket
                </NavLink> */}

                <NavLink
                  to="/slots"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  🎰 Slots
                </NavLink>

                <NavLink
                  to="/crash"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  <FaGamepad className="me-1" /> Crash
                </NavLink>

                <NavLink
                  to="/fishing"
                  className="nav-link d-flex align-items-center gap-0.5"
                >
                  <FaFish className="me-1" /> Fishing
                </NavLink>

                {/* <NavLink to="/bti" className="nav-link d-flex align-items-center gap-0.5">
                  BTi
                </NavLink>

                <NavLink to="/united-sports" className="nav-link d-flex align-items-center gap-0.5">
                  United Sports
                </NavLink> */}
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ==================== MOBILE SIDEBAR ==================== */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        className="bg-dark text-white"
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title>
            <div
              className="d-flex align-items-center"
              onClick={() => navigate("/")}
            >
              <img
                src={img1}
                alt="Logo"
                style={{ height: "50px", cursor: "pointer" }}
              />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="scroll-content" style={{ padding: "25px" }}>
          <Nav className="flex-column gap-2 fw-semibold text-uppercase">
            <NavLink to="/" className="nav-link-custom" onClick={handleClose}>
              <FaTrophy className="me-2" /> Home
            </NavLink>
            {/* <NavLink
              to="/sports"
              className="nav-link-custom"
              onClick={handleClose}
            >
              <FaTrophy className="me-2" /> Sports
            </NavLink> */}
            <NavLink
              to="/cricket"
              className="nav-link-custom"
              onClick={handleClose}
            >
              <MdSportsCricket className="me-2" /> Cricket
            </NavLink>
            <NavLink
              to="/casino"
              className="nav-link-custom"
              onClick={handleClose}
            >
              <MdCasino className="me-2" /> Live Casino
            </NavLink>
            {/* <NavLink
              to="/football"
              className="nav-link-custom"
              onClick={handleClose}
            >
              <FaFutbol className="me-2" /> Football
            </NavLink> */}
            {/* <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <MdSportsTennis className="me-2" /> Tennis
            </NavLink>
            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <FaHorse className="me-2" /> Horse Racing
            </NavLink>
            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <FaDog className="me-2" /> Greyhound Racing
            </NavLink>
            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <MdHowToVote className="me-2" /> Election
            </NavLink>
            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <GiCardRandom className="me-2" /> Aura
            </NavLink> */}

            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              🎰 Slots
            </NavLink>
            <NavLink to="#" className="nav-link-custom" onClick={handleClose}>
              <FaGamepad className="me-2" /> Crash Games
            </NavLink>
            <NavLink
              to="/fishing"
              className="nav-link-custom"
              onClick={handleClose}
            >
              <FaFish className="me-2" /> Fishing Games
            </NavLink>
            <NavLink
              to="/lucky"
              className="nav-link-custom"
              onClick={handleClose}
            >
              Sports
            </NavLink>
            {/* <NavLink
              to="/bti"
              className="nav-link-custom"
              onClick={handleClose}
            >
              BTi
            </NavLink>
            <NavLink
              to="/united-sports"
              className="nav-link-custom"
              onClick={handleClose}
            >
              United Sports
            </NavLink> */}
          </Nav>

          <div className="mt-4 d-flex flex-column gap-2">
            {!user && (
              <Button
                variant="warning"
                size="sm"
                className="fw-bold"
                onClick={() => dispatch(openLoginModal())}
              >
                <FaSignInAlt /> Log In
              </Button>
            )}
            {!user && (
              <Button
                variant="outline-warning"
                size="sm"
                className="fw-bold"
                onClick={() => {
                  handleClose();
                  setShowSignUp(true);
                }}
              >
                <FaUserPlus /> Sign Up
              </Button>
            )}
          </div>

          {/* <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setShowLangModal(true)}
          >
            <FaGlobe /> {activeLang}
          </Button> */}
        </Offcanvas.Body>
      </Offcanvas>

      <MobileMenuScroll />
      <LoginModal
        show={isLoginModalOpen}
        handleClose={() => dispatch(closeLoginModal())}
      />
      <SignUpModal show={showSignUp} handleClose={() => setShowSignUp(false)} />

      <LanguageModal
        show={showLangModal}
        onClose={() => setShowLangModal(false)}
        onSelectLang={(lang) => setActiveLang(lang.toUpperCase())}
      />
    </header>
  );
}
